<template>
  <div class="main">
    <Nav />
    <div class="container">
      <div class="box login">
        <div class="tabs">
          <ul>
            <li :class="showLogin?'is-active':'none'">
              <a v-on:click="showLogin=true">Login</a>
            </li>
            <li :class="showLogin?'none':'is-active'">
              <a v-on:click="showLogin=false">Sign up</a>
            </li>
          </ul>
        </div>
        <div class="section" v-if="showLogin">
          <h2 class="title is-2">Login</h2>

          <article class="message is-danger" v-if="$store.getters.loginError!=''">
            <div class="message-header">
              <p>Login Error!</p>
            </div>
            <div class="message-body">{{$store.getters.loginError}}</div>
          </article>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">Email</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input
                    class="input"
                    :class="{ 'is-danger': $v.loginForm.email.$error}"
                    type="text"
                    v-model.trim="$v.loginForm.email.$model"
                    placeholder="Email address"
                  />
                </div>
                <p
                  class="help is-danger"
                  v-if="!$v.loginForm.email.email"
                >Please enter your email address</p>
              </div>
            </div>
          </div>

          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">Password</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input
                    class="input"
                    :class="{ 'is-danger': $v.loginForm.password.$error}"
                    type="password"
                    v-model.trim="$v.loginForm.password.$model"
                    placeholder="Password"
                  />
                </div>
                <p
                  class="help is-danger"
                  v-if="!$v.loginForm.password.minLength"
                >Please enter your password</p>
              </div>
            </div>
          </div>

          <div class="field is-horizontal">
            <div class="field-label">
              <!-- Left empty for spacing -->
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <button
                    class="button is-primary"
                    :disabled="$v.loginForm.$invalid"
                    v-on:click="login"
                  >Login</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section" v-else>
          <h2 class="title is-2">Sign up</h2>
          <article class="message is-success" v-if="$store.getters.signupSuccess">
            <div class="message-header">
              <p>Success!</p>
            </div>
            <div class="message-body">
              You have signed up!
              <a
                class="button is-small is-primary"
                v-on:click="showLogin=true"
              >Login</a> to get started!
            </div>
          </article>
          <article class="message is-danger" v-if="$store.getters.signupError!=''">
            <div class="message-header">
              <p>Signup Error!</p>
            </div>
            <div class="message-body">{{$store.getters.signupError}}</div>
          </article>

          <div class="signup-form" v-if="!$store.getters.signupSuccess">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Name</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded">
                    <input
                      class="input"
                      type="text"
                      placeholder="First name"
                      :class="{ 'is-danger': $v.signupForm.firstName.$error}"
                      v-model.trim="$v.signupForm.firstName.$model"
                    />
                    <p
                      class="help is-danger"
                      v-if="!$v.signupForm.firstName.minLength"
                    >Please enter your first name</p>
                  </div>
                </div>

                <div class="field">
                  <div class="control is-expanded">
                    <input
                      class="input"
                      type="text"
                      placeholder="Last name"
                      :class="{ 'is-danger': $v.signupForm.lastName.$error}"
                      v-model.trim="$v.signupForm.lastName.$model"
                    />
                    <p
                      class="help is-danger"
                      v-if="$v.signupForm.lastName.$error"
                    >Please enter your last name</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Email</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      :class="{ 'is-danger': $v.signupForm.email.$error}"
                      type="text"
                      v-model.trim="$v.signupForm.email.$model"
                      placeholder="Email address"
                    />
                  </div>
                  <p
                    class="help is-danger"
                    v-if="!$v.signupForm.email.email"
                  >Please enter a valid email address</p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Invite Code</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      placeholder="123456"
                      :class="{ 'is-danger': $v.signupForm.invite.$error}"
                      v-model.trim="$v.signupForm.invite.$model"
                    />
                  </div>
                  <p
                    class="help is-danger"
                    v-if="$v.signupForm.invite.$error"
                  >Please enter your six digit invite code</p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Password</label>
              </div>

              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      type="password"
                      placeholder="Password"
                      :class="{ 'is-danger': $v.signupForm.password.$error}"
                      v-model.trim="$v.signupForm.password.$model"
                    />
                    <p
                      class="help is-danger"
                      v-if="!$v.signupForm.password.minLength"
                    >Please enter an eight digit password</p>
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      type="password"
                      placeholder="Repeat password"
                      :class="{ 'is-danger': $v.signupForm.passwordCheck.$error}"
                      v-model.trim="$v.signupForm.passwordCheck.$model"
                    />
                    <p
                      class="help is-danger"
                      v-if="!$v.signupForm.passwordCheck.minLength"
                    >Please enter an eight digit password</p>
                    <p
                      class="help is-danger"
                      v-if="!$v.signupForm.passwordCheck.sameAs"
                    >Passwords must match</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label">
                <!-- Left empty for spacing -->
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <button
                      class="button is-primary"
                      :disabled="$v.signupForm.$invalid"
                      v-on:click="signup"
                    >Sign up</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";
import axios from "axios";

import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default {
  components: {
    Nav,
    Footer
  },
  data() {
    return {
      signupForm: {
        firstName: "",
        lastName: "",
        email: "",
        invite: "",
        password: "",
        passwordCheck: ""
      },
      loginForm: {
        email: "",
        password: ""
      },
      showLogin: true
    };
  },
  computed: {},
  mounted() {},
  methods: {
    signup() {
      this.$store.dispatch("signup", { ...this.signupForm });
    },
    login() {
      this.$store.dispatch("login", { ...this.loginForm }).then(() => {
        if (this.$store.getters.token) {
          this.$router.push({ name: "moduleList" });
          this.logAction("login", {});
        }
      });
    },
    logAction: async function(action, note) {
      const body = {
        action,
        note: JSON.stringify(note)
      };
      const config = this.$store.getters.config;
      await axios.post(`${process.env.VUE_APP_API_URL}log`, body, config);
    }
  },
  validations: {
    signupForm: {
      firstName: {
        required,
        minLength: 1
      },
      lastName: {
        required
      },
      email: {
        required,
        email
      },
      invite: {
        required,
        minLength: minLength(6)
      },
      password: {
        required,
        minLength: minLength(8)
      },
      passwordCheck: {
        required,
        minLength: minLength(8),
        sameAs: sameAs("password")
      }
    },
    loginForm: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      }
    }
  }
};
</script>

<style lang='scss'>
.login {
  margin-top: 20px;
}
</style>

